// extracted by mini-css-extract-plugin
export default {"app":"style_app__kQQpV","appAltBackground":"style_appAltBackground__nIg10"};